<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
  ><path
    stroke="#98A2B3"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    d="M5 12h14"
    style="stroke:#98a2b3;stroke:color(display-p3 .5964 .6352 .7017);stroke-opacity:1"
  /></svg
>
